"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const FocusDetector_1 = __importDefault(require("./src/FocusDetector"));
exports.default = FocusDetector_1.default;
